<template>
  <div class="flex items-center">
<!--    <vs-avatar-->
<!--      :src="avatar"-->
<!--      :text="avatarText"-->
<!--      class="flex-shrink-0 mr-2"-->
<!--      size="30px"-->
<!--    />-->
    <p
      class="text-inherit truncate ..."
    >{{ params.value.name }}</p
    >
  </div>
</template>

<script>
import { storage } from "@/firebase/firebaseConfig";
export default {
  name: "CellRendererSender",
  data() {
    return {
      avatar: null,
      avatarText: ""
    };
  },
  created() {
    // 写真を登録する動線がないためコメントアウト
    // if (this.params.value.picture) {
    //   storage
    //     .child(this.params.value.picture.thumbnail_path)
    //     .getDownloadURL()
    //     .then(response => {
    //       this.avatar = response;
    //     });
    // } else {
    //   this.avatarText = this.params.value.name ? this.params.value.name.charAt( 0 ) : '';
    // }
  },
  computed: {
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/vessel-noon-report.scss";

</style>
